import Bowser from 'bowser/bundled';

function isIEbrowser() {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const platform = browser.parsedResult.browser.name;
  let answer = false;

  if (platform === 'Internet Explorer') {
    answer = true;
  }
  return answer;
}

module.exports = isIEbrowser;
